import React, { useState } from 'react'
import { Html } from '@thirstycamel/ui'
import './FaqList.css'

export interface FaqItem {
  question: string
  answer: React.ReactNode
}

export type FaqListBlock =
  | { type: 'header'; title: string }
  | { type: 'item'; question: string; answer: React.ReactNode }

export type FaqListVariant = 'dark' | 'light'

interface FaqListProps {
  faqs?: FaqItem[]
  blocks?: FaqListBlock[]
  variant?: FaqListVariant
  hideTitle?: boolean
}

function toBlocks(faqs?: FaqItem[], blocks?: FaqListBlock[]): FaqListBlock[] {
  if (blocks?.length) return blocks
  return (faqs || []).map(faq => ({
    type: 'item' as const,
    question: faq.question,
    answer: faq.answer,
  }))
}

export default function FaqList({ faqs, blocks, variant = 'dark', hideTitle }: FaqListProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)
  const listBlocks = toBlocks(faqs, blocks)

  const toggle = (index: number) => {
    setOpenIndex(current => (current === index ? null : index))
  }

  let itemIndex = 0

  return (
    <div className={`faq-section${variant === 'light' ? ' faq-section--light' : ''}`}>
      {!hideTitle && <span className="faq-title">FAQs</span>}
      {listBlocks.map((block, index) => {
        if (block.type === 'header') {
          return (
            <h2 className="faq-section-header" key={`header-${index}`}>
              {block.title}
            </h2>
          )
        }

        const faqIndex = itemIndex
        itemIndex += 1

        return (
          <div className="faq-item" key={`item-${index}`}>
            <button type="button" className="faq-question" onClick={() => toggle(faqIndex)}>
              {block.question}
              <span className="faq-icon">{openIndex === faqIndex ? '−' : '+'}</span>
            </button>
            <div className={`faq-answer ${openIndex === faqIndex ? 'open' : ''}`}>
              {typeof block.answer === 'string' ? (
                block.answer.includes('<') ? (
                  <Html html={block.answer} />
                ) : (
                  <p>{block.answer}</p>
                )
              ) : (
                <div className="faq-answer-content">{block.answer}</div>
              )}
            </div>
          </div>
        )
      })}
    </div>
  )
}
